import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'stackItemList.title',
    defaultMessage: 'Products',
    description: 'Title of the stack item list',
  },
  button: {
    create: {
      label: {
        id: 'stackItemList.button.create.label',
        defaultMessage: 'Create',
        description: 'Label of the create item button in the stack item list',
      },
    },
  },
  actions: {
    remove: {
      label: {
        id: 'stackItemList.actions.remove.label',
        defaultMessage: 'Remove',
        description: 'Label of the remove action in the stack item list',
      },
    },
  },
  createItem: {
    title: {
      id: 'stackItemList.createItem.title',
      defaultMessage: 'Create item',
      description: 'Title of the create item drawer in the stack item list',
    },
  },
  emptyMessage: {
    id: 'stackItemList.emptyMessage',
    defaultMessage: 'No products added',
    description: 'Empty message in the stack item list',
  },
};

export default defineMessages(translations);
